<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
    import { on, off } from 'view-design/src/utils/dom';
    import { setMatchMedia } from 'view-design/src/utils/assist';

    import { mapMutations } from 'vuex';

    setMatchMedia();

    export default {
        name: 'app',
        methods: {
            ...mapMutations('admin/layout', [
                'setDevice'
            ]),
            handleWindowResize () {
                this.handleMatchMedia();
            },
            handleMatchMedia () {
                const matchMedia = window.matchMedia;

                // 手机端断点提到 768px，覆盖大屏手机/竖屏平板，与 styles/mobile.less 保持一致
                if (matchMedia('(max-width: 768px)').matches) {
                    this.setDevice('Mobile');
                } else if (matchMedia('(max-width: 992px)').matches) {
                    this.setDevice('Tablet');
                } else {
                    this.setDevice('Desktop');
                }
            }
        },
        mounted () {
            on(window, 'resize', this.handleWindowResize);
            this.handleMatchMedia();
            // 通知
            // setTimeout(() => {
            //     this.$Notice.open({
            //         duration: 0,
            //         render: h => {
            //             return h('div', [
            //                 h('div', {
            //                     class: 'ivu-mb',
            //                     style: {
            //                         'line-height': 'normal'
            //                     }
            //                 }, '您可能需要以下服务：'),
            //                 h('Button', {
            //                     props: {
            //                         type: 'primary',
            //                         icon: 'md-bookmarks',
            //                         to: 'https://pro.iviewui.com/admin-pro',
            //                         target: '_blank',
            //                         size: 'small'
            //                     },
            //                     class: 'ivu-mr-8'
            //                 }, '查看文档'),
            //                 h('Button', {
            //                     props: {
            //                         icon: 'md-chatboxes',
            //                         to: 'https://pro.iviewui.com/consult',
            //                         target: '_blank',
            //                         size: 'small'
            //                     }
            //                 }, '咨询')
            //             ])
            //         }
            //     });
            // }, 3000);
        },
        beforeDestroy () {
            off(window, 'resize', this.handleWindowResize);
        }
    }
</script>
